
		import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "dreamland/jsx-runtime";
export const title = "How I dumped a rare version of BlackBerry 10";
export const description = "Dumping the NAND flash from a BlackBerry Z10 not meant for the public’s eyes.";
export const tags = ["Writeup", "Hardware"];
export const image = "/blog-images/z10_dev.jpeg";
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    code: "code",
    h2: "h2",
    img: "img",
    p: "p",
    pre: "pre",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/blog-images/z10_ebay.jpg",
        alt: "eBay listing"
      })
    }), "\n", _jsx("cap", {
      children: _jsxs("subt", {
        children: [_jsx("span", {
          class: "material-symbols",
          children: "info"
        }), "Image credit: Me."]
      })
    }), "\n", _jsx(_components.p, {
      children: "I recently came across an interesting listing on eBay. At first I thought it was a Dev Alpha B, a device sent out to developers before the release of the BlackBerry 10 platform. But upon closer inspection, I realized it more closely resembled a retail Z10, albeit with markings denoting its status as a non-consumer unit. So, I ordered it."
    }), "\n", _jsx(_components.h2, {
      children: "Initial impressions"
    }), "\n", _jsx(_components.p, {
      children: "The device arrived after a few weeks (as to be expected with international shipping), and the first thing I noticed is that when powering it on, it first showed the initial boot splash, but the screen went dark immediately after with no signs of life afterwards. After a little bit, I decided to press a few buttons, and to my surprise, I accidentally activated the screen reader. This means that the phone booted fine, but some kind of bug prevented it from initializing the display. I then connected it to an older computer and started up BlackBerry Link, and the software recognized the device."
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "Update (2025-11-31):\nIt turns out that the display backlight was off. Oops."
      }), "\n"]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["Update (2026-01-03):\nI managed to figure out that running ", _jsx(_components.code, {
          children: "displayctl power_off; displayctl power_on"
        }), " through the exposed telnet root shell brought the display up manually. I might do a quick follow up post later about all the interesting internal goodies and whatnot I was able to find."]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/blog-images/z10_link.jpeg",
        alt: "Z10 in BlackBerry Link"
      })
    }), "\n", _jsx("cap", {
      children: _jsxs("subt", {
        children: [_jsx("span", {
          class: "material-symbols",
          children: "info"
        }), "Image credit: Me."]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["The software version however didn't seem right. Instead of starting with \"10.x.x\", the version number was \"127.0.1.7295\". I decided to ask around in the ", _jsx(_components.a, {
        href: "https://discord.gg/s5jnytyvRS",
        children: "Lunar Project Discord server"
      }), ", and one member suggested running RIM's Command-Line Programmer, also known as cfp.exe. I did so, and some of the output was interesting:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        children: "Bootrom Version:       5.35.0.33\n    Hardware ID:       0x8500240A RIM BlackBerry Device\n    HW ID Override:    0x8500240A (OSTypes: 0x00000010)\n    Hardware OS ID:    0x051D0001\n    BR ID:             0xFF009000\n    Supported Bands:   0xFFFF                    ***** WARNING *****\n    Metrics Version:   6.43\n    Build Date:        Feb  7 2013\n    Build Time:        13:29:07\n    Build User:        ec_agent\n    Security:          Disabled\n"
      })
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        children: "OS Version:            127.0.1.7295 DEV\n    Hardware ID:       0x051D0001 RIM BlackBerry Device\n    Metrics Version:   3.18\n    FS Code Version:   0.0.0.0\n    Package Version:   \"\"\n    Build Date:        Sep 30 2013\n    Build Time:        13:07:49\n    Build User:        ec_agent\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "Note the \"Security: Disabled\" and the \"DEV\" suffix on the OS version. This meant that it was an internal OS version that had many security features disabled. Someone else suggested trying to connect to the device through the RNDIS network device exposed over the USB connection, which worked. There was a shell exposed over telnet with the credentials root/root, and a separate developer console on HTTP port 8080."
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/blog-images/z10_dev.jpeg",
        alt: "Dev console and root shell"
      })
    }), "\n", _jsx("cap", {
      children: _jsxs("subt", {
        children: [_jsx("span", {
          class: "material-symbols",
          children: "info"
        }), "Image credit: Me."]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["I then inserted a microSD card and used ", _jsx(_components.code, {
        children: "dd"
      }), " to extract various partitions. Finally, I uploaded the created images to the ", _jsx(_components.a, {
        href: "https://archive.org/details/z10_nand",
        children: "Internet Archive"
      }), ", where you can download them right now."]
    })]
  });
}
export function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}


		export default function Page() {
			const {wrapper: MDXLayout} = this.components || ({});
			return (
				MDXLayout 
					? _jsx(MDXLayout, { children: [_createMdxContent(this)], ...this })
					: _createMdxContent(this)
			)
		}
	